<div class="modal-header">
  <h4 class="modal-title drop-modal-title" id="modal-basic-title">SELECT SPOT</h4>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body">
  <div *ngIf="membershipPaused || balance === 'Paused'" class="membership-paused-alert" role="alert">
    Your membership is paused. Resume your subscription to book classes.
  </div>
  <table class="spot-grid" [ngStyle]="getTableStyle()">
      <tbody>
        <tr *ngFor="let row of rows">
          <ng-container *ngFor="let col of cols">
            <td *ngIf="spots[row * cols.length + col] > 0" class="spot-cell"
              [ngStyle]="{ 'width.px': cellSquareSide, 'height.px': cellSquareSide }"
              >
              <a  href="javascript:void(0)" 
                  class="spot" 
                  [ngClass]="{ 'booked': booked.includes(spots[row * cols.length + col]), 'selected': selected.includes(spots[row * cols.length + col]) }"
                  [ngStyle]="{ 'width.px': (cellSquareSide * spotAreaInCellPerc), 'height.px': (cellSquareSide * spotAreaInCellPerc), 'lineHeight.px': (cellSquareSide * spotAreaInCellPerc), 'borderRadius.px': (cellSquareSide * spotAreaInCellPerc) / 2 }"
                  (click)="!membershipPaused && balance !== 'Paused' && selectToggle(spots[row * cols.length + col])"
              >
                  <span *ngIf="!isFriend(spots[row * cols.length + col])">{{ spots[row * cols.length + col] }}</span>
                  <img *ngIf="isFriend(spots[row * cols.length + col])" class="friend-avatar rounded-circle" [src]="getFriendAvatar(spots[row * cols.length + col])" />
              </a>
            </td>
            <td *ngIf="spots[row * cols.length + col] === 0" class="spot-cell">
              <a  href="javascript:void(0)">
                  &nbsp;
              </a>
            </td>
          </ng-container>
        </tr>
        <ng-container>
          <div class="instructor-layer" [ngStyle]="getInstructorLayerStyle()">
              <div class="instructor-wrapper">
                  <img [src]="sessionDetails.InstructorDefaultAvatar" [alt]="sessionDetails.InstructorName" [title]="sessionDetails.InstructorName" class="rounded-circle" />
                  <p>{{instructorFirstName}}</p>
              </div>
          </div>
        </ng-container>
      </tbody>
    </table>
    <p *ngIf="balance !== 'Paused' && !membershipPaused" class="balance">Credit(s) remaining: {{balance}}</p>
    <a *ngIf="balance==='0' && sessionDetails.Class.Cost > 0" class="no-more-credits m-0" (click)="goToPurchase()">Purchase credits</a>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary reserve-spot-button1" [disabled]="submitted || selected.length === 0 || membershipPaused || balance === 'Paused' || ((balance===undefined || balance === '0') && sessionDetails.Class.Cost > 0)" (click)="confirmSpot()">
      <div *ngIf="submitted" class="spinner-border" role="status">
          <span class="visually-hidden">Confirming Spot...</span>
        </div>
        <span *ngIf="!submitted">RESERVE SPOT</span>
  </button>
</div>
